import React from "react";
import { useParams } from "react-router";
import { LeadDetailView } from "../components/LeadDetailView";
import { useAppStore } from "../store/useAppStore";

export function LeadDetailPage() {
  const { id } = useParams<{ id: string }>();
  const { selectedEventId } = useAppStore();

  if (!id) return null;

  return (
    <LeadDetailView
      eventId={selectedEventId ?? "evt-1"}
      leadId={id}
      audience="visitor"
    />
  );
}
